let envFile;

switch (import.meta.env.MODE) {
  case "production":
    console.log("Loading PRODUCTION environment configuration");
    envFile = await import("./environment.production.jsx");
    break;
    
  case "staging":
    console.log("Loading STAGING environment configuration");
    envFile = await import("./environment.staging.jsx");
    break;
    
  case "dev":
    console.log("Loading DEV environment configuration");
    envFile = await import("./environment.dev.jsx");
    break;
    
  case "development":
    console.log("Loading DEVELOPMENT environment configuration");
    envFile = await import("./environment.development.jsx");
    break;
    
  default:
    console.log("Loading DEFAULT (development) environment configuration");
    envFile = await import("./environment.development.jsx");
    break;
}

export const environment = envFile.environment;
